/* Step 12 add-on G1 (card 11d A10, owner: APPROVED) — 318(a) "Opinion type concluded" is the Audit summary memo's (W10) proposed
   opinion: shown read-only, with "Edit in the summary memo" (the pattern of 105(a) and the Materiality figures). One stored
   value — the memo; the server never stores the value from 318(a) (backend opinion_sync.py). EN + AR: lib/i18n/2150_s12f2_fixes.js. */
import React from "react";
import { Info } from "lucide-react";
import { Label } from "@/components/ui/label";
import { useI18n } from "@/contexts/I18nContext";

const CODES = ["unmodified", "qualified", "adverse", "disclaimer"];
export const MEMO_HREF = "/completion/summary-memo";

export default function OpinionFromMemoField({ field, value, href }) {
  const { t } = useI18n();
  const code = String(value || "").trim().toLowerCase();
  const text = CODES.includes(code) ? t(`s11c3Op.opinion.${code}`) : t("s12f2.op.blank");
  return (
    <div data-testid="op318-from-memo">
      <Label>{field.label}</Label>
      <div className="min-h-9 rounded border bg-slate-50 px-2 py-1.5 text-sm dark:bg-slate-900" dir="auto"
           data-testid={`field-${field.id}`} data-value={code}>{text}</div>
      <div className="mt-1 flex flex-wrap items-center gap-2 text-[11px] text-indigo-900 dark:text-indigo-200"
           data-testid="op318-from-memo-note">
        <Info className="h-3 w-3" /> {t("s12f2.op.readOnly")}
        <a href={href || MEMO_HREF} className="underline" data-testid="op318-edit-in-memo">{t("s12f2.op.edit")}</a>
      </div>
    </div>
  );
}
